/*eslint no-unused-vars: "off"*/
import { FETCH_USER_SUCCESS, UPDATE_USER_SUCCESS, SET_USER } from '../constants/ActionTypes';

export default function user(state, action) {
    const { type, body } = action;
    switch (type) {
        case SET_USER: {
            return {
                ...body,
                ...state,
            };
        }

        case FETCH_USER_SUCCESS:
            return body;
        case UPDATE_USER_SUCCESS: {
            const { x_logonPasswordCurrent, logonPassword, ...rest } = action.body;
            return { ...state, ...rest };
        }
        default:
            return state;
    }
}
